import client from './client';

/**
 * Operational Task lookups (payroll editor — the OperationalTaskModal's picker;
 * WCDP is the only tenant implementing operational tasks). Mirrors API
 * `GET /admin/operationalTask` (OperationalTaskController.getAllOperationalTasks
 * — flat rows, no nested project/account).
 */

export interface OperationalTaskOption {
  operationalTaskID: number;
  projectID: number;
  accountCodeID: number;
  name: string;
  accountingYear: string | null;
  job: string | null;
}

export const getOperationalTasks = async (): Promise<OperationalTaskOption[]> => {
  try {
    const response = await client.get('/admin/operationalTask');
    return (response.data ?? []) as OperationalTaskOption[];
  } catch (error) {
    console.error('Error fetching operational tasks:', error);
    throw error;
  }
};
